import { render, staticRenderFns } from "./corneaContactHome.vue?vue&type=template&id=2abade36&scoped=true&"
import script from "./corneaContactHome.vue?vue&type=script&lang=js&"
export * from "./corneaContactHome.vue?vue&type=script&lang=js&"
import style0 from "./corneaContactHome.vue?vue&type=style&index=0&id=2abade36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abade36",
  null
  
)

export default component.exports